import {
  SupportListFilters,
  SupportRequestAddItem,
} from '../types/supportTypes'

const supportRequestInit: SupportRequestAddItem = {
  reason: '',
  subject: '',
  body: '',
  sharedWithOrganisation: true,
  images: [],
}

const SUPPORT_STATUS_FILTER = [
  { label: 'All', value: 'all' },
  { label: 'Open', value: 'open' },
  { label: 'Unread', value: 'unread' },
  { label: 'Awaiting reply', value: 'awaiting_reply' },
  { label: 'Answered', value: 'answered' },
  { label: 'Closed', value: 'closed' },
]

const SUPPORT_DATE_FILTER = [
  { label: 'All dates', value: '0' },
  { label: 'Last 7 days', value: '7' },
  { label: 'Last 14 days', value: '14' },
  { label: 'Last 28 days', value: '28' },
]

const SUPPORT_ORDER_FILTER = [
  { label: 'Oldest Unanswered First', value: 'default' },
  { label: 'Latest Activity First', value: 'lastMessageAt,desc' },
  { label: 'Newest First', value: 'createdAt,desc' },
  { label: 'Oldest First', value: 'createdAt,asc' },
]

const supportFiltersInit: SupportListFilters = {
  status: 'open',
  date: '0',
  order: 'default',
}

export {
  supportRequestInit,
  SUPPORT_STATUS_FILTER,
  SUPPORT_DATE_FILTER,
  SUPPORT_ORDER_FILTER,
  supportFiltersInit,
}
